import { listBrandKit } from '@goldcast/api/backend';

import { BrandKitGetters } from './getters';
import { BrandKitMutations } from './mutations';
import { PlatformBrandKitState } from './types';

import loggerService from '@/services/logger.service';

export interface BrandKitContext {
  state: PlatformBrandKitState;
  getters: BrandKitGetters;
  commit: <k extends keyof BrandKitMutations>(mutation: k, payload?: any, config?: { root: boolean }) => any;
  dispatch: (action: string, payload?: any, root?: { root: boolean }) => Promise<any>;
}

const actions = {
  fetchBrandKit(context: BrandKitContext, orgId: string) {
    listBrandKit({ queryParams: { organization: orgId } })
      .then(brandKit => {
        context.commit('setBrandKit', { brandKit });
      })
      .catch((error: Error) => {
        loggerService.error('Error fetching brand kit', error);
      });
  }
};

export default actions;
